// src/pages/produtos/produtos/ConjuntoTab.js
import { useEffect, useState } from 'react';
import Input from '../../../components/input/Input';
import ConjuntoCad from '../combos/ConjuntoCad';
import ConjuntoSearch from '../combos/ConjuntoSearch';
import { ProdutoConjunto } from '../../../models/produtos/combos/ProdutoConjunto';
import { useYesNo } from '../../../contexts/geral/YesNoContext';
import { useProdutoConjunto } from '../../../contexts/produtos/combos/ProdutoConjuntoContext';
import { IoMdAddCircle } from 'react-icons/io';
import { MdDelete } from 'react-icons/md';

const ConjuntoTab = ({
    produto,
    // setProduto,
    disableCampos,
}) => {
    const { showYesNo } = useYesNo();
    const { produtoConjuntosDetalhado, addProdutoConjunto, deleteProdutoConjunto } = useProdutoConjunto();        
    const [produtoConjunto, setProdutoConjunto] = useState(new ProdutoConjunto());

    const [showConjuntoCad, setShowConjuntoCad] = useState(false);
    const [showSearchConjunto, setShowSearchConjunto] = useState(false);

    useEffect(() => {
        setProdutoConjunto(new ProdutoConjunto());
    }, [produto.id]);


    const handleRemoveProdutoConjunto = async (item) => {
      const resposta = await showYesNo("Deseja remover o item?");
        if (resposta) {
            await deleteProdutoConjunto(item.id);
        }
    }

    const handleSelectConjunto = (conjuntoSel) => {
        setProdutoConjunto({
            ...produtoConjunto,
            conjuntoId: conjuntoSel.id,
            conjunto: conjuntoSel
        });
        setShowSearchConjunto(false);
    };

    const handleSalvaProdutoConjunto = (e) => {
        e.preventDefault();
        const payload = {
        ...produtoConjunto,
        produtoId: produto.id,
        };
        delete payload.produto;
        delete payload.conjunto;

        addProdutoConjunto(payload);         
    };


    return (        
        <div>
            <div className="input-group" style={{marginBottom:'10px', alignItems:'end'}}>
                <Input
                    label="Conjunto"
                    value={produtoConjunto.conjuntoId || ''}
                    onChange={(e) => setProdutoConjunto({ ...produtoConjunto, conjuntoId: e.target.value })}
                    //onBlur={handleExit}
                    disabled={disableCampos}
                    btnBuscarDisabled={disableCampos}
                    btnAddDisabled={disableCampos}
                    btnBuscar={() => setShowSearchConjunto(true)}
                    btnAdd={() => setShowConjuntoCad(true)}
                />
                <Input
                    //label="Nome do Conjunto"
                    value={produtoConjunto.conjunto?.nome || ''}
                    //onChange={(e) => setProdutoConjunto({ ...produtoConjunto, nome: e.target.value })}                    
                    size={300}
                    disabled
                />
                
                {produto?.id > 0 && (
                    <div style={{ marginTop: "8px" }}>
                        <button                        
                            className="btn btn-secondary"
                            onClick={(e) => handleSalvaProdutoConjunto(e)}
                        >
                            <IoMdAddCircle /> Adicionar
                        </button>
                    </div>
                )}
            </div>
            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th style={{width:'100px'}}>Código</th>
                            <th>Descrição</th>
                            <th style={{width:'100px'}}>Qtd Itens</th>
                            <th style={{width:'100px'}}>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {produtoConjuntosDetalhado.map((item, index) => (
                            <tr key={index}>
                                <td style={{ textAlign: 'right' }}>{item.conjuntoId}</td>
                                <td>{item.conjunto?.nome}</td>                                        
                                <td style={{ textAlign: 'right' }}>
                                    {item.conjunto?.qtdMax}
                                </td>
                                <td style={{ textAlign:'center' }}>
                                    <button
                                        type="button" // <-- ESSENCIAL             
                                        style={{
                                                backgroundColor: '#dc3545', // vermelho
                                                color: '#fff',
                                                border: 'none',
                                                borderRadius: '15%', // ou use '8px' para leve arredondamento
                                                padding: '4px 8px',
                                                cursor: 'pointer'
                                                }}                                                 
                                        onClick={() => handleRemoveProdutoConjunto(item)}
                                    >
                                    <MdDelete />
                                    </button>            
                                </td>
                            </tr>
                        ))}
                        {produtoConjuntosDetalhado.length === 0 && (
                            <tr>
                                <td colSpan="3" className="text-center">
                                    Nenhum item cadastrado
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>     
            {/* Combos */}
            <ConjuntoCad
                show={showConjuntoCad}
                onHide={() => setShowConjuntoCad(false)}
                onSelectProduto={() => alert('selecionou')}
            />
            <ConjuntoSearch
                show={showSearchConjunto}
                onHide={() => setShowSearchConjunto(false)}
                onSelectConjunto={handleSelectConjunto}
            />               
        </div>
    );
};

export default ConjuntoTab;